import type { AuthProvider } from "@/app/oauth/types";
import type { ApiClient } from "@/lib/api";

export const createOAuthProvider = async (options: {
  client: ApiClient;
  oauthProvider: AuthProvider;
}) => {
  const { client, oauthProvider } = options;

  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  const payload = { ...(oauthProvider as unknown as Record<string, unknown>) };
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  (payload as Record<string, unknown>).binding = undefined;

  const { data } = await client.post<AuthProvider>(
    "/auth_providers",
    // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
    payload as AuthProvider
  );
  return data;
};
